import { _ as _Hash } from "./auth-service-tools1332.js";
import { _ as _ListCache } from "./auth-service-tools1182.js";
import { _ as _Map } from "./auth-service-tools1197.js";
var Hash = _Hash,
    ListCache = _ListCache,
    Map = _Map;

function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    "hash": new Hash(),
    "map": new (Map || ListCache)(),
    "string": new Hash()
  };
}

var _mapCacheClear = mapCacheClear;
export { _mapCacheClear as _ };